'use client';

import { useState } from 'react';
import { CreditCard } from 'lucide-react';
import PopupTemplate from '@/app/ui/popupTemplate';
import UserBalancePopup, { getCurrentUrlForCallback } from '@/app/subscription/user-credit/frontend/userBalancePopup';
import { useTranslations } from 'next-intl';

interface InsufficientCreditPopupProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function InsufficientCreditPopup({ isOpen, onClose }: InsufficientCreditPopupProps) {
  const t = useTranslations('popup.insufficientCredit');
  const [showBalancePopup, setShowBalancePopup] = useState(false);

  const handleUserBalanceClick = () => {
    setShowBalancePopup(true);
    onClose();
  };

  return (
    <>
      <PopupTemplate
        isOpen={isOpen}
        onClose={onClose}
        closeable={true}
        isTransparent={false}
      >
        <div className="p-8">
          {/* Header */}
          <div className="text-center mb-6">
            <div className="flex justify-center mb-4">
              <CreditCard className="h-12 w-12 text-white" />
            </div>
            <h2 className="text-white text-xl font-semibold mb-2">{t('lowGems')}</h2>
            <p className="text-gray-300 text-sm leading-relaxed">
              {t('addMoreGemsMessage')}
            </p>
          </div>

          {/* Action button */}
          <div className="space-y-4">
            <button
              onClick={handleUserBalanceClick}
              className="w-full flex items-center justify-center gap-3 bg-indigo-600 hover:bg-indigo-700 text-white font-medium py-3 px-4 rounded-xl transition-all duration-200 transform hover:scale-[1.02] hover:shadow-lg"
            >
              <span>{t('addMoreGems')}</span>
            </button>
          </div>
        </div>
      </PopupTemplate>

      {/* User Balance Popup */}
      <UserBalancePopup
        isOpen={showBalancePopup}
        onClose={() => setShowBalancePopup(false)}
        callbackBaseUrl={getCurrentUrlForCallback()}
      />
    </>
  );
} 